import '../styles/LandingStepRail.css';
import React from 'react';

const STEPS = [
  { num: '01', name: 'Entry', active: true },
  { num: '02', name: 'Identity', active: false },
  { num: '03', name: 'Extraction', active: false },
  { num: '04', name: 'Leads', active: false },
];

function StepItems() {
  return (
    <>
      {STEPS.map((step) => (
        <li
          key={step.num}
          className={`lsr-step${step.active ? ' lsr-step--active' : ''}`}
          aria-current={step.active ? 'step' : undefined}
        >
          {step.active ? <span className="lsr-marker" aria-hidden="true" /> : null}
          <span className="lsr-num">{step.num}</span>
          <span className="lsr-name">{step.name}</span>
        </li>
      ))}
    </>
  );
}

function LandingStepRail() {
  return (
    <section className="lsr-root" aria-labelledby="lsr-heading">
      <h2 id="lsr-heading" className="lsr-label">
        Steps
      </h2>

      <nav className="lsr-strip" aria-label="Landing steps">
        <ol className="lsr-list">
          <StepItems />
        </ol>
      </nav>

      <nav className="lsr-column" aria-label="Landing steps">
        <ol className="lsr-list">
          <StepItems />
        </ol>
      </nav>
    </section>
  );
}

export default LandingStepRail;